/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.alert-success\":\"Grønn sirkel med sjekkmerke\"}");